import styled from '@emotion/styled';
import Button from 'components/Button/Button';

export const NewFileButtonStyled = styled(Button)`
  text-transform: none;
  background: #265183;
`;
